import InvoiceTable from "./InvoiceTable";
import SubscriptionTable from "./SubscriptionTable";

export default function CustomerPayment({ boxes = [], invoiceData = [] }) {
  // const [flag, setFlag] = useState("none");
  // const [note, setNote] = useState("");
  // const [data, setData] = useState(invoiceData);

  const handleView = (row, index) => {
    console.log(row, index);
  };

  return (
    <div>
      <InvoiceTable data={invoiceData} onView={handleView} />
      <div className="my-8">
        <SubscriptionTable data={boxes} />
      </div>
      {/* <Paper className="p-4 mt-4" elevation={4}>
        <CustomText variant="h6" bold={600}>
          Actions
        </CustomText>
        <div className="flex flex-wrap items-center">
          <div className="py-2">
            <CustomText variant="body" bold={600}>
              FLAG CUSTOMER
            </CustomText>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                onChange={(e) => setFlag(e.target.value)}
                value={flag}
              >
                <FormControlLabel
                  value="none"
                  control={<Radio />}
                  label={
                    <CustomText variant="body" bold={700}>
                      No Flags
                    </CustomText>
                  }
                />
                <FormControlLabel
                  value="orange"
                  control={<Radio />}
                  label={
                    <CustomText variant="body" bold={700}>
                      Orange Flag
                    </CustomText>
                  }
                />
                <FormControlLabel
                  value="red"
                  control={<Radio />}
                  label={
                    <CustomText variant="body" bold={700}>
                      Red Flag
                    </CustomText>
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="flex-1 py-2">
            <CustomText variant="body" bold={600}>
              SET CUSTOMER NOTE
            </CustomText>
            <EditFormControl
              className="py-1"
              size="small"
              placeholder="Customer note here"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              fullWidth
            />
          </div>
        </div>
        <CustomText variant="h6" bold={600}>
          Actions
        </CustomText>
        <Button variant="contained" color ="secondary">
          Send Password Reset Mail
        </Button>
      </Paper> */}
    </div>
  );
}
